export default __webpack_public_path__ + "static/media/pictogramBeaconInternational128.64cf2cff.svg";